import { createApi } from "@reduxjs/toolkit/query/react";
import request from "../request";

const axiosBaseQuery =
	() =>
	async ({ url, method = "GET", params, body, skipGlobalLoader = true }) => {
		try {
			const config = { skipGlobalLoader };
			let data;
			switch (method) {
				case "POST":
					data = await request.post(url, body, config);
					break;
				case "PUT":
					data = await request.put(url, body, config);
					break;
				case "PATCH":
					data = await request.patch(url, body, config);
					break;
				case "DELETE":
					data = await request.delete(url, config);
					break;
				default:
					data = await request.get(url, { params, ...config });
			}
			return { data };
		} catch (error) {
			return {
				error: {
					status: error?.statusCode || "CUSTOM_ERROR",
					data: error,
				},
			};
		}
	};

export const baseApi = createApi({
	reducerPath: "api",
	baseQuery: axiosBaseQuery(),
	tagTypes: [
		"ProjectMember",
		"PermissionPreset",
		"AdminPermissionTemplate",
		"Role",
		"RolePermission",
		"AdminProjects",
		"AdminUsers",
		"AdminUserProjects",
		"ProjectPlanning",
		"CostTracking",
		"ManualEntry",
		"BoQ",
		"LV",
		"Aufmass",
		"Ticket",
		"Project",
		"Invoice",
		"TicketCategory",
		"ProjectCompany",
		"SupplierInfo",
	],
	endpoints: () => ({}),
});
